import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody,
} from 'reactstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { Can } from '../../utilities/Can';
// import { post } from '../../helpers/api_helper';
// import * as url from '../../helpers/url_helper';

function SlackApproval(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col sm="4" />
          <Col xxl="4">
            <Card>
              <CardBody>
                <Can i="see" this="slack">
                  <div className="text-center">
                    <span className="mdi mdi-slack" style={{ fontSize: '198px', position: 'relative' }}>
                      <span
                        className="mdi mdi-timer-sand mdi-spin"
                        style={{
                          fontSize: '48px',
                          position: 'absolute',
                          left: '158px',
                          top: '175px',
                        }}
                      />
                    </span>
                  </div>
                </Can>

                <Can not i="see" this="slack"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
          <Col sm="4" />
        </Row>
      </div>
    </div>
  );
}

SlackApproval.defaultProps = {
  t: (x) => (x),
};

SlackApproval.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(SlackApproval));
